class CollectionPage extends HTMLElement {
  connectedCallback() {
    this.bind();
    let view;
    try { view = localStorage.getItem('dc-view'); } catch {}
    if (view) this.setView(view);
  }

  bind() {
    this.querySelector('[data-open-filters]')?.addEventListener('click', () => this.querySelector('[data-filters]').showModal());
    this.querySelector('[data-close-filters]')?.addEventListener('click', () => this.querySelector('[data-filters]').close());
    this.querySelectorAll('[data-view]').forEach((b) => b.addEventListener('click', () => this.setView(b.dataset.view)));
    const form = this.querySelector('#CollFilters');
    const sort = this.querySelector('[data-sort]');
    form?.addEventListener('submit', (e) => { e.preventDefault(); this.querySelector('[data-filters]').close(); this.load(this.urlFromForm()); });
    form?.addEventListener('change', (e) => { if (e.target.type === 'checkbox') this.load(this.urlFromForm(), false); });
    sort?.addEventListener('change', () => this.load(this.urlFromForm()));
    this.querySelectorAll('[data-link]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); this.load(a.href); }));
    if (this.dataset.view) this.setView(this.dataset.view);
  }

  urlFromForm() {
    const params = new URLSearchParams();
    const form = this.querySelector('#CollFilters');
    if (form) for (const [k, v] of new FormData(form)) if (v !== '') params.append(k, v);
    const sort = this.querySelector('[data-sort]');
    if (sort) params.set('sort_by', sort.value);
    return `${location.pathname}?${params}`;
  }

  setView(view) {
    this.dataset.view = view;
    this.querySelectorAll('[data-view]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.view === view));
    try { localStorage.setItem('dc-view', view); } catch {}
  }

  async load(url, closeDrawer = true) {
    this.classList.add('is-loading');
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', this.dataset.section);
    try {
      const html = await (await fetch(u)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('collection-page');
      const keepOpen = !closeDrawer && this.querySelector('[data-filters]')?.open;
      const view = this.dataset.view;
      this.innerHTML = fresh.innerHTML;
      if (view) this.dataset.view = view;
      this.bind();
      this.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
      if (keepOpen) this.querySelector('[data-filters]')?.showModal();
      u.searchParams.delete('section_id');
      history.replaceState({}, '', u);
    } catch {
      location.href = url;
    } finally {
      this.classList.remove('is-loading');
    }
  }
}
customElements.define('collection-page', CollectionPage);
